export default __webpack_public_path__ + "static/media/1.066ec9e3.jpg";